import { Solar4gCaptureInfo } from '@EcamModel/model';
import PopUpBase from '@components/PopUpBase';
import { IPopUp } from '@hooks/usePopUp';
import { Autocomplete, Button, Stack, TextField, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { imageTypeMapping } from './CaptureManagementMilesightCameraSolar';
import _ from 'lodash';
import { FormValues } from './PopUpEditUploadSetting';
import { useCameraDetailContext } from '../../hook/CameraDetailsProvider';
import useMileSightSolar from '@pages/cameras/hook/useMilesightSolar';
import useMedia from '@hooks/useMedia';

type Props = Omit<IPopUp, 'onConfirm'> & {};

export default function PopUpEditImageSettings(props: Props) {
    const { open, onClose } = props;

    const { isMediumMD, isMobileSM } = useMedia()

    const { Solar4gCaptureInfo, valueImageSettings } = useMileSightSolar();

    const { control, reset } = useForm<Partial<Solar4gCaptureInfo & FormValues>>({
        mode: 'all',
        defaultValues: {},
    });

    useEffect(() => {
        if (!open) return;
        reset({
            Width: Solar4gCaptureInfo?.Width,
            Height: Solar4gCaptureInfo?.Height,
            ImageType: Solar4gCaptureInfo?.ImageType,
        });
    }, [open]);

    return (
        <PopUpBase
            open={open}
            onClose={onClose}
            onConfirm={() => { }}
            dialogProps={{
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: '10px',
                        maxWidth: '700px',
                    },
                    zIndex: (theme) => theme.zIndex.modal,
                },
            }}
            title={
                <Stack>
                    <Typography variant="h4">Image setting</Typography>
                </Stack>
            }
            titleProps={{ '&.MuiDialogTitle-root': { paddingTop: '24px' } }}
            subTitleProps={{ sx: { color: 'gray' } }}
            minWidthButton={150}
            desc={
                <Stack width={isMediumMD ? 'auto' : "550px"} sx={{ background: '#FAFAFA', p: 2 }} spacing={2}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Typography sx={{ width: 200 }}>Image settings:</Typography>
                        <Stack width={'100%'}>
                            <Controller
                                name="ImageSettings"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label={'Image settings'}
                                        value={valueImageSettings || 'Image settings'}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    />
                                )}
                            />
                        </Stack>
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Typography sx={{ width: 200 }}>Image type:</Typography>
                        <Stack width={'100%'}>
                            <Controller
                                name="ImageType"
                                control={control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        label={'Image type'}
                                        value={
                                            !_.isNil(Solar4gCaptureInfo?.ImageType)
                                                ? imageTypeMapping[Solar4gCaptureInfo?.ImageType ?? 0]
                                                : 'Image type'
                                        }
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                    />
                                )}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            }
            customActions={
                // <Stack direction={'row'} width="100%" justifyContent="space-between">
                //     <Button
                //         sx={{ minWidth: 130 }}
                //         variant="cancel"
                //         onClick={() => {
                //             props.onClose?.();
                //         }}
                //     >
                //         Cancel
                //     </Button>
                //     <Button
                //         sx={{ minWidth: 130 }}
                //         variant="contained"
                //         // disabled={disabled}
                //         // onClick={handleSubmit(handleSave)}
                //     >
                //         Save
                //     </Button>
                // </Stack>
                <Button
                    sx={{ minWidth: 130 }}
                    variant="cancel"
                    onClick={() => {
                        props.onClose?.();
                    }}
                >
                    Cancel
                </Button>
            }
        />
    );
}
